import EL, { HTMLELEMENT } from '../../EL/EL.js';
import Hideable, { Hide, Show } from '../../../interface/Hideable.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const navAttr = makeAttrStruct([
    ['class'],
    ['name']
]);
export const navData = makeDataStruct();
export const navModel = makeStruct();
// Simplified Model
export function nav(className, name) {
    return {
        attributes: navAttr(className, name),
        data: navData()
    };
}
/** Generic NAV Element */
export default class NAV extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.NAV, model);
        this.implement(new Hideable(this));
    }
}
export { EL, Hide, Hideable, Show };
